import { useState } from "react";

import { LogoMark } from "./LogoMark";

type LogoProps = {
  compact?: boolean;
  /** "lockup" is the header size; "display" is the oversized footer treatment. */
  variant?: "lockup" | "display";
};

export function Logo({ compact = false, variant = "lockup" }: LogoProps) {
  const [active, setActive] = useState(false);

  return (
    <a
      className={variant === "display" ? "logo logo--display" : "logo"}
      href="/"
      aria-label="Backbone home"
      onBlur={() => {
        setActive(false);
      }}
      onFocus={() => {
        setActive(true);
      }}
      onPointerEnter={() => {
        setActive(true);
      }}
      onPointerLeave={() => {
        setActive(false);
      }}
    >
      <LogoMark active={active} />
      {!compact && <span className="logo__word">Backbone</span>}
    </a>
  );
}
